// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartLineStyles } from "@ces/App/Components/MiniCart/MiniCartLineCard";
import AlertWarning from "@ces/XDL/Icons/AlertWarning";
import Trash from "@ces/XDL/Icons/Trash";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@ces/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

miniCartLineStyles.cartLine = {
    css: css`
        display: grid;
        grid-template-columns: 92px 1fr 16px;
        position: relative;
        gap: 8px;
    `,
};

miniCartLineStyles.imageWrapper = {
    css: css`
        grid-column: 1 / 2;
        position: relative;
        &,
        ${TypographyStyle} {
            display: flex;
            align-items: flex-start;
        }
        .tooltip-container {
            position: absolute;
            padding: 5px 4px;
            background-color: ${color("common.white", 0.66)};
        }
    `,
};

miniCartLineStyles.cartLineImage = {
    width: "92px",
    height: "92px",
    css: css`
        max-height: 100%;
        max-width: 100%;
        border-radius: 2px;
        overflow: hidden;
        img {
            aspect-ratio: 1/1;
            object-fit: contain;
            height: auto;
        }
    `,
};

miniCartLineStyles.detailsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        grid-column: 2 / 3;
    `,
};

miniCartLineStyles.lineDescription = {
    color: "text",
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        lineHeight: "14px",
        css: css`
            letter-spacing: 0;
            ${ellipsis(2)}
        `,
    },
};

miniCartLineStyles.qtyAndPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: flex-start;
        gap: 4px;
        margin-top: auto;
    `,
};

miniCartLineStyles.basicProductPriceStyles = {
    price: {
        priceText: {
            variant: "h6",
            css: css`
                margin: 0;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                mergeCss: true,
                weight: fontConfig.weight.regular,
                size: 12,
                css: css`
                    letter-spacing: 0;
                    line-height: 13px;
                `,
            },
        },
    },
};

miniCartLineStyles.removeCartLineLink = {
    icon: {
        iconProps: {
            src: Trash,
            size: 16,
            color: "text.link",
        },
    },
    css: css`
        grid-column: 3 / 4;
        align-items: start;
        height: fit-content;
        ${IconWrapper} {
            opacity: 1;
        }
    `,
};

miniCartLineStyles.errorMessagesWrapper = {
    css: css`
        width: 100%;
        margin-top: 10px;
        & > div:not(:last-child) {
            margin-bottom: 15px;
        }
    `,
};

miniCartLineStyles.warningIcon = {
    src: AlertWarning,
    size: 14,
    color: "warning",
};

miniCartLineStyles.qtyContainer = {
    css: css`
        display: flex;
        gap: 5px;
        align-items: center;
        min-width: 114px;
    `,
};

miniCartLineStyles.loginMessage = {
    size: 10,
    lineHeight: "11px",
    color: "common.ui6",
    css: css`
        ${wrapInContainerStyles}
        display: inline;
        flex: 1;
    `,
};

miniCartLineStyles.alertWarningIconStyles = {
    size: 20,
    css: css`
        &,
        & > svg {
            height: 18px;
            opacity: 0.66;
            color: ${color("warning")};
            &:hover {
                opacity: 1;
            }
        }
    `,
};

miniCartLineStyles.warningToolTip = {
    mergeCss: true,
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};
